
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Cabserviceinthane() {



    const cardData =
    {
        keyword: ' Cab Service in Thane',
        heading: 'Deva Cabs:  Cab Service in Thane',
        headingDescription: 'Deva Cabs offers reliable, comfortable, and hassle-free cab services in Thane and surrounding areas. Whether you are traveling for work, shopping, or leisure, our experienced drivers and well-maintained fleet ensure a safe and smooth ride. Thane’s mix of urban and green spaces makes it a busy yet scenic destination, and we help you move around with ease. With multiple vehicle options to suit your preferences, Deva Cabs guarantees a convenient and comfortable travel experience every time.',

        top: 'Top Places to Visit in Thane with Deva Cabs',

   "topPlaces": [
    {
      "title": "Upvan Lake",
      "location": "Thane, Maharashtra",
      "description": "Upvan Lake is one of the most serene and picturesque spots in Thane, surrounded by lush greenery and the scenic Yeoor Hills. Popular for morning walks, boating, and cultural events, the lake offers a peaceful escape from the urban hustle. It becomes especially vibrant during festivals like Sanskruti Arts Festival, when the entire area transforms into a cultural hub with music, art, and food. It's an ideal destination for families, couples, and nature lovers."
    },
    {
      "title": "Tikuji-ni-Wadi",
      "location": "Thane, Maharashtra",
      "description": "Tikuji-ni-Wadi is a well-known amusement and water park located in Thane, making it a top weekend getaway for families. The park offers a wide range of activities including water slides, wave pools, go-karting, a dinosaur park, and a Shiva temple. With lush surroundings and ample recreational options, it's perfect for a fun-filled day with kids or a group of friends. The park is especially popular during school vacations and festive seasons."
    },
    {
      "title": "Yeoor Hills",
      "location": "Thane, Maharashtra",
      "description": "Located within the Sanjay Gandhi National Park’s Thane range, Yeoor Hills is a green paradise offering tranquil nature trails, wildlife sightings, and panoramic views of Thane city. Popular among trekkers and morning walkers, the hills are home to various flora and fauna, including leopards, deer, and exotic birds. Local tribal communities reside here, and eco-tourism initiatives are being promoted. It’s a must-visit for those seeking nature, photography, or quiet weekend getaways."
    },
    {
      "title": "Kopineshwar Temple",
      "location": "Thane West, Maharashtra",
      "description": "Kopineshwar Temple is one of the oldest and most revered temples in Thane, dedicated to Lord Shiva. Believed to date back to the 11th century, it stands as a testament to Thane’s rich spiritual heritage. The temple features a striking Shivalinga and traditional Maratha-style architecture. Devotees visit in large numbers during Mahashivratri and Shravan months. Its spiritual ambiance and historical significance make it a peaceful place for worship and reflection."
    },
    {
      "title": "Masunda Lake (Talao Pali)",
      "location": "Thane West, Maharashtra",
      "description": "Masunda Lake, also known as Talao Pali, is a central recreational spot in Thane. Adorned with a charming lakefront promenade and boating facilities, it’s an excellent spot for family outings and evening strolls. The large statue of Lord Shiva in the middle of the lake is a prominent feature. Surrounded by food stalls and local shops, the lake offers both leisure and cultural glimpses into Thane’s daily life. Illuminated beautifully at night, it creates a calming yet lively environment."
    },
    {
      "title": "Ovalekar Wadi Butterfly Garden",
      "location": "Ghodbunder Road, Thane",
      "description": "Ovalekar Wadi Butterfly Garden is a hidden gem for nature enthusiasts and photographers. It is home to over 130 species of butterflies, including rare and seasonal varieties. Unlike traditional gardens, this space is left in its natural state to provide the ideal habitat for butterflies. Visitors can observe the entire lifecycle of butterflies, from caterpillars to pupae to winged beauties. It’s a perfect educational and leisure spot for families and students alike."
    },
    {
      "title": "Kelva Beach",
      "location": "Palghar (near Thane)",
      "description": "Located around 80 km from Thane, Kelva Beach is a popular coastal retreat known for its long sandy stretch, swaying palm trees, and peaceful surroundings. The beach is less commercialized compared to Mumbai's beaches, making it ideal for weekend getaways. Nearby attractions include the historic Kelva Fort and the tranquil Shitladevi Temple. It’s perfect for beach lovers, photographers, and those looking to unwind by the sea."
    },
    {
      "title": "Suraj Water Park",
      "location": "Waghbil, Thane",
      "description": "Suraj Water Park is an award-winning theme park located in Thane that combines fun and mythology. Featuring massive water slides, a wave pool, and Asia's longest artificial cave, the park offers attractions for all age groups. It has also earned a place in the Limca Book of Records for its fiberglass cave and fiber-glass Lord Shiva statue. Clean, well-maintained, and packed with entertainment, it’s a must-visit for families during the summer months."
    },
    {
      "title": "Thane Creek Flamingo Sanctuary",
      "location": "Airoli, Thane",
      "description": "The Thane Creek Flamingo Sanctuary is a haven for bird watchers and wildlife photographers. Spanning over 1,690 hectares of mangroves and mudflats, it hosts thousands of migratory flamingos and other bird species between November and May. The sanctuary also offers a boat safari for a closer view of these majestic birds. As one of India’s few urban biodiversity zones, it plays a vital role in conservation and ecological education."
    },
    {
      "title": "Ghodbunder Fort",
      "location": "Ghodbunder, Thane",
      "description": "Perched on a hill near the Ulhas River, Ghodbunder Fort is a historical site built by the Portuguese in the 16th century. Although now in ruins, the fort still offers breathtaking views of the Thane Creek and surrounding greenery. It's a peaceful location for history buffs and those interested in colonial architecture. The area around the fort is being developed for tourism and is gradually becoming a hotspot for weekend exploration."
    }
  ],



"services": [
    {
        "name": "Thane to Pune Cab",
        "description": "Travel conveniently from Thane to Pune with Deva Cabs' premium intercity taxi service. Our Thane to Pune cab service is ideal for business trips, family travel, or weekend getaways. We offer a wide range of vehicles, including sedans, SUVs, and tempo travellers, ensuring the perfect ride for every group size. Our professional drivers are punctual and experienced in highway travel, providing a safe, smooth journey. With transparent pricing, clean vehicles, and 24/7 customer support, Deva Cabs ensures your Pune trip starts on the right note from Thane."
    },
    {
        "name": "Cab Booking in Thane Made Easy",
        "description": "At Deva Cabs, we’ve simplified cab booking in Thane for your convenience. Whether you need a cab for a short trip, a full day of errands, or a long-distance journey, our seamless online booking system allows you to reserve your ride in just a few clicks. Choose your vehicle type, set your schedule, and relax — our team handles the rest. Our fleet is regularly serviced, and our drivers are background-verified to ensure a safe and reliable experience every time you ride with us in Thane."
    },
    {
        "name": "Car Rental in Thane for Outstation Adventures",
        "description": "Planning an outstation trip from Thane? Deva Cabs offers flexible and affordable car rental options perfect for weekend escapes, pilgrimages, or long holidays. Whether you're heading to Lonavala, Goa, Nashik, or beyond, our outstation rental service ensures a comfortable and enjoyable journey. With a wide variety of well-maintained vehicles, you can travel in style and comfort with professional drivers who know the best routes. Choose hourly or per-day rentals and travel at your own pace with full support from our team."
    },
    {
        "name": "Thane to Airport Cab",
        "description": "Need a dependable airport transfer? Deva Cabs offers prompt and efficient cab services from Thane to Mumbai Airport (both Domestic and International terminals). Avoid the stress of traffic or public transport with our door-to-door airport cab service. Our drivers are punctual, familiar with airport routes, and track your flight for any delays to ensure timely pick-up or drop-off. Book your airport cab in advance or last minute — we're available 24/7 to serve you with safe and comfortable rides."
    },
    {
        "name": "Thane to Mahabaleshwar Cab",
        "description": "Escape to the cool hills of Mahabaleshwar with Deva Cabs’ reliable cab service from Thane. Our long-distance cab services are perfect for family vacations, romantic getaways, or group tours. Enjoy breathtaking views, winding mountain roads, and a stress-free travel experience in our comfortable cabs. All vehicles come with experienced drivers who prioritize your safety and comfort. Book your Mahabaleshwar ride easily online and benefit from competitive pricing and round-the-clock customer support."
    },
    {
        "name": "Taxi Service in Thane West",
        "description": "Deva Cabs is proud to serve the Thane West community with professional and efficient taxi services. Whether you need a daily ride to work, a trip to the market, or a weekend travel plan, our cabs are always nearby. We offer both one-way and round-trip packages with clear pricing and no hidden charges. Our drivers know the Thane West area thoroughly, so you’ll get to your destination on time, every time. Book your cab instantly via phone, app, or website."
    },
    {
        "name": "Thane to Bandra Taxi Fare",
        "description": "Planning a trip from Thane to Bandra? Deva Cabs provides a reliable and affordable taxi service with transparent fare estimates. Our Thane to Bandra route is serviced by experienced drivers who ensure a smooth and timely ride. You can choose from multiple vehicle options depending on your comfort and budget. Avoid the hassle of public transport and enjoy a direct, comfortable ride to Bandra with upfront pricing and professional service."
    },
    {
        "name": "Thane to Borivali Taxi Fare",
        "description": "Deva Cabs offers convenient and economical taxi services from Thane to Borivali. Whether you’re commuting for work, attending a family event, or running errands across town, we ensure a comfortable ride with fixed, transparent fares. Our courteous drivers and clean vehicles make every journey pleasant. You can book in advance or request a ride on-demand — either way, our team is here to make your Thane to Borivali trip as smooth as possible."
    },
    {
        "name": "Thane to Igatpuri Taxi",
        "description": "Heading to the serene hills of Igatpuri? Deva Cabs provides dedicated cab services from Thane to Igatpuri for nature lovers, trekkers, and families looking for a weekend escape. Our vehicles are ideal for long journeys, with spacious seating and professional drivers who are familiar with the scenic route. Sit back and enjoy the beautiful views while we ensure a safe and comfortable ride to one of Maharashtra’s most picturesque destinations."
    },
    {
        "name": "Thane to Mumbai Airport Cab",
        "description": "Deva Cabs specializes in fast and efficient airport transfers from Thane to Mumbai Airport. Whether you're catching a flight or returning home, our cab service ensures timely pickups and smooth rides to both Domestic and International terminals. We monitor traffic and flight timings to give you peace of mind, and our clean, AC-equipped vehicles ensure a comfortable experience from door to door. Choose us for dependable airport cab service at competitive rates."
    },
    {
        "name": "Thane to Panchgani Cab",
        "description": "Explore the beauty of Panchgani with Deva Cabs’ outstation cab service from Thane. Our long-distance travel packages offer maximum comfort, with flexible departure times, spacious vehicles, and skilled drivers who ensure a safe journey through hilly terrain. Whether it's a family outing, romantic getaway, or solo trip, Deva Cabs takes care of all your travel needs. Book online or through our customer support team and enjoy competitive fares with no hidden charges."
    }
],

"tableData": [
    ["Thane to Pune Cab", "-Cab Booking in Thane Made Easy"],
    ["Car Rental in Thane for Outstation Adventures", "-Thane to Airport Cab"],
    ["Thane to Mahabaleshwar Cab", "-Taxi Service in Thane West"],
    ["Thane to Bandra Taxi Fare", "-Thane to Borivali Taxi Fare"],
    ["Thane to Igatpuri Taxi", "-Thane to Mumbai Airport Cab"],
    ["Thane to Panchgani Cab", ""]
],

whychoose: [
  {
    "WhyChooseheading": "Reliable and On-Time Pickup in Thane",
    "WhyChoosedescription": "Deva Cabs takes punctuality seriously. Our professional drivers are always on time, ensuring that your travel plans are never delayed. Whether you’re heading to an office in Wagle Estate, catching a train at Thane station, or planning a weekend getaway, we provide prompt pickups and reliable drop-offs across all parts of Thane. You can trust us for a hassle-free experience, every time you book."
  },
  {
    "WhyChooseheading": "Spacious, Clean, and Comfortable Vehicles",
    "WhyChoosedescription": "Our cabs are thoughtfully maintained to deliver the highest level of comfort. Each vehicle—whether it's a compact car or a spacious SUV—is clean, air-conditioned, and equipped with modern features. With Deva Cabs, you'll enjoy plush seating, smooth suspension, and ample luggage space, making even the longest rides across Thane or to neighboring cities a relaxing affair."
  },
  {
    "WhyChooseheading": "Well-Trained, Courteous Drivers",
    "WhyChoosedescription": "Our drivers are selected for their knowledge of Thane’s roads and their commitment to customer satisfaction. Courteous, well-groomed, and experienced, they ensure you have a smooth journey—free from the stress of traffic or navigation. Whether you're new to the city or a daily commuter, our drivers will get you to your destination safely and efficiently, while maintaining a professional attitude throughout."
  },
  {
    "WhyChooseheading": "Fair and Transparent Fare Structure",
    "WhyChoosedescription": "Say goodbye to overcharging and hidden fees. Deva Cabs offers completely transparent pricing with detailed fare breakdowns before your ride. Whether you book a local trip, outstation cab, or airport transfer, you'll always know what you're paying for. No surge pricing during peak hours or last-minute surprises—just honest fares you can depend on."
  },
  {
    "WhyChooseheading": "Available Anytime, Anywhere in Thane",
    "WhyChoosedescription": "Deva Cabs operates 24/7 to meet your transportation needs, no matter the hour. Whether it’s an early morning airport drop from Ghodbunder Road or a late-night pickup from a friend's place in Kolshet, our fleet is always available. Just book through our app, website, or call center, and we’ll be at your doorstep—on time, every time."
  },
  {
    "WhyChooseheading": "Highest Standards of Safety",
    "WhyChoosedescription": "Your safety is non-negotiable. Our cabs come equipped with GPS, speed governors, airbags, and safety belts. Each vehicle is routinely inspected and sanitized. Our drivers follow all traffic rules and drive responsibly to ensure that you and your loved ones reach your destination securely. With Deva Cabs, peace of mind comes standard with every ride."
  },
  {
    "WhyChooseheading": "Fast, Simple Booking Process",
    "WhyChoosedescription": "Booking a cab in Thane has never been easier. With our user-friendly mobile app and website, you can book a ride in seconds. Prefer human assistance? Our customer support team is just a phone call away and ready to help you with bookings, special requests, or inquiries. Enjoy instant confirmations and real-time driver tracking with every reservation."
  },
  {
    "WhyChooseheading": "Custom Travel Solutions for Every Need",
    "WhyChoosedescription": "Whether you’re commuting to work, attending a wedding, going on a business trip, or planning a weekend escape, Deva Cabs has a travel plan for you. Choose from hourly rentals, one-way drops, round-trip packages, and airport services—all tailored to your schedule and preferences. We’re flexible, so your journey can be, too."
  }
]


















    }




const faqData = [
  {
    question: "How can I book a cab with Deva Cabs in Thane?",
    answer: "You can book a cab easily via our website, mobile app, or by contacting our customer support. We offer quick and convenient booking for all your travel needs in Thane."
  },
  {
    question: "Which areas in Thane are covered by Deva Cabs?",
    answer: "Deva Cabs operates across all major areas of Thane including Thane West, Thane East, Ghodbunder Road, Majiwada, Hiranandani Estate, and more."
  },
  {
    question: "What vehicle options are available with Deva Cabs in Thane?",
    answer: "We offer a variety of vehicle options including hatchbacks, sedans, SUVs, and premium cars to suit your travel style and group size."
  },
  {
    question: "Is Deva Cabs available 24/7 in Thane?",
    answer: "Yes, our cab services in Thane are available 24 hours a day, 7 days a week. You can rely on us for early morning pickups or late-night travel."
  },
  {
    question: "Can I book an outstation cab from Thane with Deva Cabs?",
    answer: "Yes, we provide outstation cab services from Thane to cities like Mumbai, Pune, Nashik, Lonavala, and more. Advance booking is recommended for best availability."
  },
  {
    question: "Does Deva Cabs offer airport transfers from Thane?",
    answer: "Yes, we offer seamless airport pick-up and drop-off services from Thane to Mumbai Airport for both domestic and international terminals."
  },
  {
    question: "What are the payment options for Deva Cabs in Thane?",
    answer: "We accept cash, credit/debit cards, UPI, and online payments through our mobile app or website."
  },
  {
    question: "Is it safe to travel with Deva Cabs at night in Thane?",
    answer: "Absolutely. All our cabs are GPS-enabled and driven by verified drivers. We ensure a safe and secure ride, even at night."
  },
  {
    question: "Can I pre-schedule a ride with Deva Cabs in Thane?",
    answer: "Yes, you can schedule your ride in advance through our booking portal or app. Choose your preferred date and time for guaranteed pickup."
  },
  {
    question: "Why choose Deva Cabs for cab service in Thane?",
    answer: "Deva Cabs offers reliable service, clean cars, professional drivers, and fair pricing. Whether it's a short trip within Thane or an outstation journey, we ensure comfort and punctuality."
  }
];

const testimonialData = [
  {
    id: 1,
    name: 'Mr. Nilesh Patkar',
    role: 'Daily Commuter',
    review: 'Deva Cabs is my go-to service for traveling around Thane. The drivers are always punctual, and the cars are in excellent condition. Great experience every time!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 2,
    name: 'Ms. Rucha Desai',
    role: 'IT Professional',
    review: 'I use Deva Cabs for my daily office commute from Thane to Powai. The service is consistent and safe, even during late-night shifts.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];

























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Thane",
  "image": "https://devacab.com/assets/images/cab-service-in-thane.jpg", // Replace with actual image URL
  "description": "Deva Cabs offers reliable cab service in Thane for airport transfers, city tours, corporate travel, weddings, outstation trips, and monthly rentals. Choose from luxury and economy cabs tailored to your needs.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "2800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "530",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/cab-service-in-thane" // Replace with actual page URL
  }
};




    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Cab Service in Thane | Taxi Booking & Airport Cab | Deva Cabs</title>
  <meta 
    name="description" 
    content="Book dependable cab service in Thane with Deva Cabs. Offering airport transfers, city tours, corporate travel, weddings, outstation trips, and monthly cab rentals. Affordable luxury and economy cabs available." 
  />
  <meta 
    name="keywords" 
    content="Cab Service in Thane, Thane taxi booking, Thane local cab service, Thane airport cab, Thane city tour cab, Thane corporate cab, Thane wedding car hire, Thane outstation taxi, Thane monthly cab rental, Thane chauffeur service, Thane cab near me, Affordable Thane cab, Luxury cab Thane, Book cab online Thane, Economy cab Thane, Premium cab Thane, Family cab Thane, Thane cab for events" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/3.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Cabserviceinthane;